import React, { Component } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faCloudArrowUp,
  faCopy,
  faFile,
  faFilePdf,
  faFolderOpen,
  faFolderPlus,
  faImage,
  faTrashCan
} from '@fortawesome/free-solid-svg-icons';
import Logo from './assets/Logo_EPS_300.png';

const mediaRegex = /\.(jpg|jpeg|png|gif|svg|mp4|webm|mov)$/i;
const pdfRegex = /\.pdf$/i;
const psdRegex = /\.psd$/i;
const ignoredRegex = /\.(ico|html|json|ttf|txt)$/i;

const fileRoute = (fullRoute, value) => encodeURI('/content-application' + fullRoute + '/' + value);

const openFile = (route) => {
  window.open(route, '_blank', 'noopener,noreferrer');
};

const DeleteConfirmation = ({deletion, onCancel, onConfirm}) => {
  if (!deletion) return null;
  return (
    <div className="eps-confirm-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onCancel(); }}>
      <div className="eps-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="eps-confirm-title">
        <span className="eps-confirm-icon"><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /></span>
        <h2 id="eps-confirm-title">Confirmer la suppression</h2>
        <p>Voulez-vous vraiment supprimer <strong>« {deletion.name} »</strong> ?</p>
        {deletion.kind === 'folder' && <small>Le dossier et son contenu seront supprimés.</small>}
        <div className="eps-confirm-actions">
          <button type="button" className="eps-confirm-cancel" onClick={onCancel}>Annuler</button>
          <button type="button" className="eps-confirm-delete" onClick={onConfirm}><FontAwesomeIcon icon={faTrashCan} aria-hidden="true" /> Supprimer</button>
        </div>
      </div>
    </div>
  );
};

const FileCard = ({name, route, kind, onCopy, onDelete}) => {
  const preview = kind === 'media'
    ? <img src={route} alt={name} />
    : kind === 'pdf'
      ? <FontAwesomeIcon icon={faFilePdf} aria-hidden="true" />
      : <FontAwesomeIcon icon={faFile} aria-hidden="true" />;

  return (
    <article className="eps-file-card">
      <button type="button" className="eps-file-card-open" onClick={() => openFile(route)} aria-label={'Ouvrir ' + name}>
        <span className={'eps-file-preview eps-file-preview-' + kind}>{preview}</span>
        <span className="eps-file-name" title={name}>{name}</span>
      </button>
      <div className="eps-file-card-actions">
        <button type="button" className="eps-file-copy" aria-label={'Copier l’URL de ' + name} title="Copier l’URL" onClick={(event) => { event.stopPropagation(); onCopy(); }}>
          <FontAwesomeIcon icon={faCopy} aria-hidden="true" />
        </button>
        <button type="button" className="eps-file-delete" aria-label={'Supprimer ' + name} title="Supprimer" onClick={(event) => { event.stopPropagation(); onDelete(); }}>
          <FontAwesomeIcon icon={faTrashCan} aria-hidden="true" />
        </button>
      </div>
    </article>
  );
};

const FolderCard = ({name, onOpen, onDelete}) => (
  <article className="eps-folder-card-wrap">
    <button type="button" className="eps-folder-card" onClick={onOpen} aria-label={'Ouvrir le dossier ' + name}>
      <FontAwesomeIcon icon={faFolderOpen} aria-hidden="true" />
      <span title={name}>{name}</span>
      <small>Ouvrir</small>
    </button>
    <button type="button" className="eps-file-delete eps-folder-delete" aria-label={'Supprimer le dossier ' + name} title="Supprimer" onClick={(event) => { event.stopPropagation(); onDelete(); }}>
      <FontAwesomeIcon icon={faTrashCan} aria-hidden="true" />
    </button>
  </article>
);

const ListFiles = ({allFiles, fullRoute, loadNewFile, previousFile, requestDelete, copyFileUrl, onChangeHandler, onClickHandler, onChangeHandler2, onClickHandler2, newFolder, showFolderForm, toggleFolderForm, selectedFile, loading, error, actionMessage, deletion, cancelDelete, confirmDelete}) => {
  const values = Array.from(Array.isArray(allFiles) ? allFiles : []).filter((value) => value && value[0] !== '.');
  const folders = values.filter((value) => !mediaRegex.test(value) && !pdfRegex.test(value) && !psdRegex.test(value) && !ignoredRegex.test(value));
  const files = values.filter((value) => mediaRegex.test(value) || pdfRegex.test(value) || psdRegex.test(value));
  const routeParts = fullRoute.split('/').filter(Boolean);

  return (
    <div className="eps-file-page">
      <header className="eps-file-header">
        <button type="button" className="eps-file-back" onClick={() => { window.location.href = '/dashboard'; }}>
          <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" />
          <span>Tableau de bord</span>
        </button>
        <img src={Logo} className="eps-file-logo" alt="Accès EPS" />
        <div className="eps-file-header-spacer" aria-hidden="true" />
      </header>

      <main className="eps-file-main">
        <section className="eps-file-panel">
          <div className="eps-file-heading">
            <div className="eps-file-title-group">
              <span className="eps-file-title-icon"><FontAwesomeIcon icon={faImage} aria-hidden="true" /></span>
              <div>
                <h1>Bibliothèque d’images</h1>
                <p>Gérez les images, vidéos et documents utilisés dans vos activités.</p>
              </div>
            </div>
            <div className="eps-file-actions">
              <label className="eps-file-action eps-file-action-primary">
                <FontAwesomeIcon icon={faCloudArrowUp} aria-hidden="true" />
                <span>Importer</span>
                <input type="file" accept="video/mp4,video/x-m4v,video/*,image/*,.pdf,.psd" multiple onChange={(event) => onChangeHandler(event.target.files)} />
              </label>
              <button type="button" className="eps-file-action eps-file-action-secondary" onClick={toggleFolderForm}>
                <FontAwesomeIcon icon={faFolderPlus} aria-hidden="true" />
                <span>Nouveau dossier</span>
              </button>
            </div>
          </div>

          <div className="eps-file-toolbar">
            <nav className="eps-file-breadcrumb" aria-label="Chemin actuel">
              <button type="button" className={!fullRoute ? 'is-current' : ''} onClick={() => { if (fullRoute) window.location.href = '/image'; }}>Bibliothèque</button>
              {routeParts.map((part, index) => <React.Fragment key={part + index}><span>/</span><span className={index === routeParts.length - 1 ? 'is-current' : ''}>{part}</span></React.Fragment>)}
            </nav>
            {fullRoute && <button type="button" className="eps-file-previous" onClick={previousFile}><FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" /> Précédent</button>}
          </div>

          {showFolderForm && (
            <form className="eps-folder-form" onSubmit={(event) => { event.preventDefault(); onClickHandler2(); }}>
              <FontAwesomeIcon icon={faFolderPlus} aria-hidden="true" />
              <input type="text" value={newFolder} placeholder="Nom du nouveau dossier" onChange={(event) => onChangeHandler2(event.target.value)} autoFocus />
              <button type="submit" className="eps-file-form-button">Créer</button>
              <button type="button" className="eps-file-form-cancel" onClick={toggleFolderForm}>Annuler</button>
            </form>
          )}

          {selectedFile && selectedFile.length > 0 && (
            <div className="eps-file-upload-ready">
              <span>{selectedFile.length} fichier{selectedFile.length > 1 ? 's' : ''} sélectionné{selectedFile.length > 1 ? 's' : ''}</span>
              <button type="button" onClick={onClickHandler}>Lancer l’import</button>
            </div>
          )}

          {error && <div className="eps-file-message eps-file-message-error" role="alert">{error}</div>}
          {actionMessage && <div className="eps-file-message" role="status">{actionMessage}</div>}

          {loading ? (
            <div className="eps-file-empty"><span className="eps-file-spinner" aria-hidden="true" /><p>Chargement des fichiers…</p></div>
          ) : (
            <>
              {folders.length > 0 && <section className="eps-file-section"><h2>Dossiers</h2><div className="eps-folder-grid">{folders.map((name) => <FolderCard key={name} name={name} onOpen={() => loadNewFile(name)} onDelete={() => requestDelete({ kind: 'folder', name, path: fullRoute + '/' + name })} />)}</div></section>}
              {files.length > 0 && <section className="eps-file-section"><h2>Fichiers</h2><div className="eps-file-grid">{files.map((name) => { const kind = mediaRegex.test(name) ? 'media' : pdfRegex.test(name) ? 'pdf' : 'psd'; const route = fileRoute(fullRoute, name); return <FileCard key={name} name={name} kind={kind} route={route} onCopy={() => copyFileUrl(route)} onDelete={() => requestDelete({ kind: 'file', name, path: fullRoute + '/' + name })} />; })}</div></section>}
              {folders.length === 0 && files.length === 0 && <div className="eps-file-empty"><span className="eps-file-empty-icon"><FontAwesomeIcon icon={faFolderOpen} aria-hidden="true" /></span><h2>Dossier vide</h2><p>Importez un fichier ou créez un dossier pour commencer.</p></div>}
            </>
          )}
        </section>
      </main>
      <DeleteConfirmation deletion={deletion} onCancel={cancelDelete} onConfirm={confirmDelete} />
    </div>
  );
};

class TestClass extends Component {
  constructor(props) {
    super(props);
    this.state = { allFiles: [], fullRoute: '', arrayRoute: [], selectedFile: [], newFolder: '', showFolderForm: false, loading: true, error: null, actionMessage: null, deletion: null };
  }

  loadCycle() {
    const formData = new FormData();
    formData.append('route', '');
    axios.post('/api/getFiles', formData)
      .then((res) => this.setState({ allFiles: res.data || [], arrayRoute: [''], loading: false, error: null }))
      .catch(() => this.setState({ loading: false, error: 'Impossible de charger les fichiers.' }));
  }

  loadCycle2(route) {
    const formData = new FormData();
    formData.append('route', route);
    this.setState({ loading: true });
    axios.post('/api/getFiles', formData)
      .then((res) => this.setState({ allFiles: res.data || [], loading: false, error: null }))
      .catch(() => this.setState({ loading: false, error: 'Impossible de charger ce dossier.' }));
  }

  loadNewFile(value) {
    const route = this.state.fullRoute + '/' + value;
    const arrayRoute = this.state.arrayRoute.concat(value);
    const formData = new FormData();
    formData.append('route', route);
    this.setState({ loading: true });
    axios.post('/api/getFiles', formData)
      .then((res) => this.setState({ allFiles: res.data || [], fullRoute: route, arrayRoute, loading: false, error: null }))
      .catch(() => this.setState({ loading: false, error: 'Impossible d’ouvrir ce dossier.' }));
  }

  previousFile() {
    const arrayRoute = this.state.arrayRoute.slice(0, -1);
    const route = arrayRoute.filter(Boolean).map((value) => '/' + value).join('');
    this.setState({ fullRoute: route, arrayRoute }, () => this.loadCycle2(route));
  }

  onChangeHandler(files) { this.setState({ selectedFile: Array.from(files || []), actionMessage: null }); }

  onChangeHandler2(newFolder) { this.setState({ newFolder }); }

  onClickHandler() {
    if (!this.state.selectedFile.length) return this.setState({ actionMessage: 'Sélectionnez au moins un fichier.' });
    const data = new FormData();
    this.state.selectedFile.forEach((file, index) => data.append(String(index), file));
    data.append('path', this.state.fullRoute);
    axios.post('/api/uploadFile', data)
      .then(() => this.setState({ selectedFile: [], actionMessage: 'Import terminé.' }, () => this.loadCycle2(this.state.fullRoute)))
      .catch(() => this.setState({ actionMessage: 'L’import a échoué.' }));
  }

  onClickHandler2() {
    const newFolder = this.state.newFolder.trim();
    if (!newFolder) return this.setState({ actionMessage: 'Saisissez un nom de dossier.' });
    const data = new FormData();
    data.append('path', this.state.fullRoute);
    data.append('newFolder', newFolder);
    axios.post('/api/createFolder', data)
      .then(() => this.setState({ newFolder: '', showFolderForm: false, actionMessage: 'Dossier créé.' }, () => this.loadCycle2(this.state.fullRoute)))
      .catch(() => this.setState({ actionMessage: 'La création du dossier a échoué.' }));
  }

  copyFileUrl(route) {
    const url = window.location.origin + route;
    const copy = navigator.clipboard && window.isSecureContext
      ? navigator.clipboard.writeText(url)
      : new Promise((resolve, reject) => {
          const textarea = document.createElement('textarea');
          textarea.value = url;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          try {
            document.execCommand('copy') ? resolve() : reject(new Error('copy failed'));
          } catch (error) {
            reject(error);
          }
          document.body.removeChild(textarea);
        });
    copy.then(() => this.setState({ actionMessage: 'URL copiée dans le presse-papiers.' }))
      .catch(() => this.setState({ actionMessage: 'Impossible de copier cette URL.' }));
  }

  deleteImage(path) { const data = new FormData(); data.append('path', path); axios.post('/api/deleteFile', data).then(() => this.loadCycle2(this.state.fullRoute)).catch(() => this.setState({ error: 'La suppression a échoué.' })); }
  deletePath(path) { const data = new FormData(); data.append('path', path); axios.post('/api/deletePath', data).then(() => this.loadCycle2(this.state.fullRoute)).catch(() => this.setState({ error: 'La suppression a échoué.' })); }
  requestDelete(deletion) { this.setState({ deletion }); }
  cancelDelete() { this.setState({ deletion: null }); }
  confirmDelete() {
    const deletion = this.state.deletion;
    if (!deletion) return;
    this.setState({ deletion: null, actionMessage: 'Suppression en cours…' });
    if (deletion.kind === 'folder') this.deletePath(deletion.path);
    else this.deleteImage(deletion.path);
  }

  componentDidMount() { this.loadCycle(); }

  render() {
    return <ListFiles {...this.state} loadNewFile={this.loadNewFile.bind(this)} previousFile={this.previousFile.bind(this)} requestDelete={this.requestDelete.bind(this)} copyFileUrl={this.copyFileUrl.bind(this)} onChangeHandler={this.onChangeHandler.bind(this)} onClickHandler={this.onClickHandler.bind(this)} onChangeHandler2={this.onChangeHandler2.bind(this)} onClickHandler2={this.onClickHandler2.bind(this)} cancelDelete={this.cancelDelete.bind(this)} confirmDelete={this.confirmDelete.bind(this)} toggleFolderForm={() => this.setState((state) => ({ showFolderForm: !state.showFolderForm, actionMessage: null }))} />;
  }
}

export default TestClass;
